import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import LibraryIcon from "@mui/icons-material/LocalLibrary";

interface ADPMenuProps {
  onProvinceSelect: (province: string) => void;
}

const topMargin = 8;
const buttonTextStyle = {
  marginTop: topMargin,
  marginRight: "10px",
  marginLeft: "5px",
};
const buttonIconStyle = { color: "#498c49" };

const ADPMenuButton: React.FC<ADPMenuProps> = ({ onProvinceSelect }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const provinces = ["Punjab", "Sindh", "KPK", "Balochistan", "AJK", "Gilgit"];

  const handleClick = (e: React.MouseEvent<HTMLElement>) =>
    setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelect = (province: string) => {
    handleClose();
    onProvinceSelect(province.toLowerCase()); // convert to lowercase for API
  };

  return (
    <div>
      <IconButton
        edge="start"
        color="inherit"
        aria-label="projects"
        onClick={handleClick}
      >
        <LibraryIcon sx={buttonIconStyle} />{" "}
        <h5 style={buttonTextStyle}>ADP Projects</h5>
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {provinces.map((p) => (
          <MenuItem key={p} onClick={() => handleSelect(p)}>
            {p}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default ADPMenuButton;
